import React from 'react';
import InsightsContainer from '../../../view/cmn/insight/InsightsContainer';
import tourSteps from '../TourSteps';
import SarasTour from '../../../library/navigate/SarasTour';

const Home = ({deviceInfo}) => {
    return (
        <>
            <SarasTour steps={tourSteps} tourKey={'home'}/>
            <InsightsContainer deviceInfo={deviceInfo}></InsightsContainer>
        </>
    )
}

export default Home;